/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InsuranceClaimsAction/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import SubMenuTab from 'DesignSystem/SubMenuTab/index'
import TysiaIconDescription from 'DesignSystem/Svgs/TysiaIconDescription/index'



/** @type {import('Simple/types.js').View} */
export default function InsuranceClaimsAction({
  children,
  viewPath = "/App/Account/Content/Financial/Tabs/InsuranceClaimsAction"
  
}) {
let tabSelectedTabValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.tab',
})
let constantData = 'insurance_claims'
let aggregateData = fromAggregate.equals(tabSelectedTabValueData, constantData)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Insurance Claims"
 onClick={onClick}
 data="tab.selected.tab"
 data="'insurance_claims'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 marginTop={dtSpaceXs}
>
{childProps => (
<TysiaIconDescription
{...childProps}
  viewPath={`${viewPath}/TysiaIconDescription`}
/>
)}
</SubMenuTab>
{children}
</React.Fragment>)
}